<app-template-checkbox [disabled]="disabled" [value]="value" [control]="control" [options]="options" [label]="label" />
